"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportStagePublicEnum = exports.ReportStageEnum = void 0;
var ReportStageEnum;
(function (ReportStageEnum) {
    ReportStageEnum["created"] = "created";
    ReportStageEnum["prepareArchive"] = "prepareArchive";
    ReportStageEnum["querying"] = "querying";
    ReportStageEnum["rendering"] = "rendering";
    ReportStageEnum["done"] = "done";
    ReportStageEnum["failed"] = "failed"; // На случай возникновения ошибки
})(ReportStageEnum || (exports.ReportStageEnum = ReportStageEnum = {}));
var ReportStagePublicEnum;
(function (ReportStagePublicEnum) {
    ReportStagePublicEnum["preparing"] = "preparing";
    ReportStagePublicEnum["done"] = "done";
    ReportStagePublicEnum["failed"] = "failed";
})(ReportStagePublicEnum || (exports.ReportStagePublicEnum = ReportStagePublicEnum = {}));
//# sourceMappingURL=MessageAnalyticsReports.interface.js.map